import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div>
      <header>
        <h1>Termos e condições gerais de uso</h1>
        <h2>Plataforma Parko</h2>

        <p>
          Os serviços da plataforma Parko são fornecidos pela pessoa física com o seguinte nome: Luciano Marco Melo Silva, inscrito no CPF sob o nº 064.950.185.33, titular da propriedade intelectual sob o aplicativo e website pertencentes à plataforma Parko.
        </p>

        <h3>1. DO OBJETO</h3>
        <p>
          A plataforma visa licenciar o uso de seu website e aplicativo, fornecendo ferramentas para auxiliar e dinamizar o dia a dia dos seus usuários. A plataforma caracteriza-se pela prestação do seguinte serviço: gerenciamento de estacionamento e reserva de vagas em estabelecimentos contratados pela plataforma Parko.
        </p>

        <h3>2. DA ACEITAÇÃO</h3>
        <p>
          O presente Termo estabelece obrigações contratadas, por tempo indeterminado, entre a plataforma e as pessoas físicas, usuárias do aplicativo Parko. Ao utilizar a plataforma o usuário aceita integralmente as presentes normas e compromete-se a observá-las, sob o risco de aplicação das penalidades cabíveis.
          A aceitação do presente instrumento é imprescindível para o acesso e a utilização da plataforma Parko. Caso não concorde com as disposições deste instrumento, o usuário não deve utilizá-lo.
        </p>

        <h3>3. DO ACESSO DOS USUÁRIOS</h3>
        <p>
          Serão utilizadas todas as soluções técnicas à disposição do proprietário pela plataforma para permitir o acesso ao serviço 24 (vinte e quatro) horas por dia, 7 (sete) dias por semana. No entanto, a navegação na plataforma ou em alguma de suas páginas poderá ser interrompida, limitada ou suspensa para atualizações, modificações ou qualquer ação necessária ao seu bom funcionamento.
        </p>

        <h3>4. DO CADASTRO</h3>
        <p>
          O acesso às funcionalidades da plataforma pelos usuários exigirá a realização de um cadastro prévio, com o fornecimento de dados de identificação pessoal: nome e sobrenome, telefone, endereço de e-mail com senha e o nº do CPF. Os dados cadastrados deverão ser completos, recentes e válidos, sendo de sua exclusiva responsabilidade manter referidos dados atualizados, bem como o usuário se compromete com a veracidade dos dados fornecidos.
        </p>
        <p>
          O usuário se compromete a não informar seus dados cadastrais e/ou de acesso à plataforma a terceiros, responsabilizando-se integralmente pelo uso que deles seja feito.
        </p>
        <p>
          Mediante a realização do cadastro o usuário declara e garante expressamente ser plenamente capaz, podendo exercer e usufruir livremente dos serviços oferecidos.
        </p>
        <p>
          Após a confirmação do cadastro, o usuário possuirá um login e uma senha pessoal, a qual assegura ao usuário o acesso individual à mesma. Desta forma, compete ao usuário exclusivamente a manutenção de referida senha de maneira confidencial e segura, evitando o acesso indevido às informações pessoais.
        </p>
        <p>
          Toda e qualquer atividade realizada com o uso da senha será de responsabilidade do usuário, que deverá informar prontamente a plataforma em caso de uso indevido da respectiva senha.
        </p>
        <p>
          Não será permitido ceder, vender, alugar ou transferir, de qualquer forma, a conta, que é pessoal e intransferível.
        </p>
        <p>
          O usuário poderá, a qualquer tempo, requerer o cancelamento de seu cadastro junto ao aplicativo Parko. O seu descadastramento será realizado o mais rapidamente possível, desde que não sejam verificados débitos em aberto.
        </p>
        <p>
          O usuário ao aceitar os Termos e Política de Privacidade, autoriza expressamente a plataforma a coletar, usar, armazenar, tratar, ceder ou utilizar as informações derivadas do uso dos serviços, do site e quaisquer plataformas, incluindo todas as informações preenchidas pelo usuário no momento em que realizar ou atualizar seu cadastro, além de outras expressamente descritas na <a href="#">Política de Privacidade</a> que deverá ser autorizada pelo usuário.
        </p>

        <h3>5. DO SERVIÇO</h3>
        <p>
          A plataforma conta com os principais serviços e funcionalidades de pagamento da reserva do estacionamento, reserva de vaga, disponibilidade de vagas, comparativo de preço, estimativa de tempo para chegada no destino, redirecionamento do cliente para geolocalização de preferência, a capacidade de estender o tempo de reserva, cancelar a reserva e utilizar uma central de ajuda para solucionar problemas e desentendimentos com os clientes.
        </p>
        <p>
          O aplicativo realizará a função de redirecionar o cliente pela sua geolocalização de preferência, assim como também fará acompanhamento da reserva da vaga do estacionamento do estabelecimento contratado desde o horário de chegada e de saída do usuário no local, considerando o tempo de tolerância de permanência na vaga estipulado pela empresa parceira.
        </p>

        <h3>6. DA GESTÃO FINANCEIRA</h3>
        <p>
          A plataforma não se reserva no direito de reajustar os valores do estacionamento, pois estes já são previamente estabelecidos pela empresa contratada. Cabe apenas à plataforma avisar com antecedência sobre o valor a ser pago pelo usuário.
        </p>
        <p>
          Apenas em caso de antecipação ou ultrapassagem do prazo de permanência na vaga o usuário será notificado pelo aplicativo e o valor fixo sofrerá alteração.
        </p>
        <p>
          Para a utilização do serviço, a plataforma poderá solicitar as informações financeiras do usuário, como CPF, endereço de cobrança e dados de cartões. Ao inserir referidos dados o usuário concorda que sejam cobrados, de acordo com a forma de pagamento que venha a ser escolhida, os preços então vigentes e informados pela empresa contratada. Referidos dados financeiros poderão ser armazenados para facilitar acessos e pagamentos futuros.
        </p>

        <h3>7. DO CANCELAMENTO</h3>
        <p><strong>O serviço poderá ser cancelado por:</strong></p>
        <ul>
          <li>a) parte do usuário: nessas condições o serviço deixará de ser prestado caso o usuário desative a sua conta do aplicativo sem que haja débitos em aberto.</li>
          <li>b) violação dos Termos de Uso: os serviços serão cessados imediatamente.</li>
        </ul>

        <h3>8. DO SUPORTE</h3>
        <p>
          Em caso de qualquer dúvida, sugestão ou problema com a utilização da plataforma, o usuário poderá entrar em contato com a central de ajuda, através do email ou telefone.
          Estes serviços de atendimento ao usuário estarão disponíveis nos seguintes dias e horários: segunda a sexta, de 8h às 18h e no sábado, de 8h às 12h.
        </p>

        <h3>9. DAS RESPONSABILIDADES</h3>
        <p><strong>É de responsabilidade do usuário:</strong></p>
        <ul>
          <li>A correta utilização da plataforma e do serviço oferecido, prezando pela ocupação adequada da vaga, pelo respeito ao tempo de tolerância de permanência e pelo pagamento da reserva;</li>
          <li>O cumprimento e respeito ao conjunto de regras disposto neste Termo de Condições Geral de Uso, na respectiva Política de Privacidade e na legislação nacional e internacional;</li>
          <li>A proteção aos dados de acesso à sua conta/perfil (login e senha);</li>
          <li>Garantir a declaração íntegra dos acontecimentos e atualizações das operações no aplicativo, bem como feedbacks dos estacionamentos, correta declaração dos momentos de entrada e saída.</li>
        </ul>

        <p><strong>É de responsabilidade da plataforma Parko:</strong></p>
        <ul>
          <li>Realizar o acompanhamento da reserva, indicando o tempo de permanência do usuário na vaga e evidenciando o preço a ser pago por ele ao estabelecimento;</li>
          <li>Alertar antecipadamente sobre eventuais sanções aplicadas contra o usuário;</li>
          <li>Responder pelas situações em que o problema foi gerado pela Parko e reembolsar o usuário, caso não consiga ocupar a vaga por falha do sistema ou do estacionamento;</li>
          <li>A plataforma não se responsabiliza pela perda de bens pessoais ou do ticket de estacionamento, sendo responsabilidade do usuário o registro de ocorrência no app.</li>
        </ul>

        <h3>10. DOS DIREITOS AUTORAIS</h3>
        <p>
          O presente Termo de Uso concede aos usuários uma licença não exclusiva, não transferível e não sublicenciável, para acessar e fazer uso da plataforma.
        </p>
        <p>
          Todos os direitos de propriedade intelectual sobre a estrutura da plataforma, conteúdos, design, marcas e sistemas são reservados à Parko, conforme as leis brasileiras vigentes.
        </p>

        <h3>11. DAS SANÇÕES</h3>
        <ul>
          <li>Advertência, suspensão ou banimento da conta do usuário que violar o termo ou apresentar comportamento fraudulento;</li>
          <li>Reincidência de cancelamentos indevidos poderá gerar suspensão de 1 semana ou banimento definitivo;</li>
          <li>Sanções por comportamento doloso ou ofensivo a terceiros.</li>
        </ul>

        <h3>12. DAS MULTAS E SUSPENSÃO DE CONTA</h3>
        <ul>
          <li>Reincidência de cancelamento por vaga ocupada indevidamente poderá gerar multa, suspensão ou banimento;</li>
          <li>Pessoa jurídica que não cumprir a reserva poderá pagar multa de 100% do valor à Parko.</li>
        </ul>

        <h3>13. DA RESCISÃO</h3>
        <p>
          A não observância das obrigações poderá ensejar a rescisão unilateral e imediata do presente Termo pela Parko.
        </p>

        <h3>14. DAS ALTERAÇÕES</h3>
        <p>
          Os termos poderão ser alterados a qualquer tempo, sendo disponibilizados pela plataforma para nova aceitação do usuário.
        </p>

        <h3>15. DA POLÍTICA DE PRIVACIDADE</h3>
        <p>
          Além deste Termo, o usuário deverá consentir com os termos descritos na Política de Privacidade.
        </p>

        <h3>16. DO FORO</h3>
        <p>
          Para resolução de litígios será aplicado o Direito brasileiro, com foro na comarca da sede da empresa.
        </p>
      </header>
    </div>
  );
}

export default App;
